import pluralize from 'pluralize';

function crash(key) {
  return key.split(/(?=[A-Z])|_/g);
}

function transform(key, multiple = true) {
  const broken = crash(key);
  const last = broken.length - 1;

  broken[last] = pluralize[multiple ? 'plural' : 'singular'](broken[last]);

  return broken.join('_').toLowerCase();
}

export function plural(key) {
  return transform(key, true);
}

export function singular(key) {
  return transform(key, false);
}

export default function (key, custom) {
  const multiple = transform(key, true);
  const single = transform(key, false);

  return {
    create: single,
    read: single,
    update: single,
    delete: single,
    list: multiple,
    ...custom,
  };
}
